import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

// Loading component
const PageLoader = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-white text-xl">Loading...</div>
  </div>
);

// Lazy load all pages for better performance
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Services = lazy(() => import("./pages/Services"));
const Etiquette = lazy(() => import("./pages/Etiquette"));
const TributeGifts = lazy(() => import("./pages/TributeGifts"));
const Travel = lazy(() => import("./pages/Travel"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Contact = lazy(() => import("./pages/Contact"));
const Booking = lazy(() => import("./pages/Booking"));

// Lazy load admin pages
const AdminLogin = lazy(() => import("./admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./admin/AdminDashboard"));
const ImageManager = lazy(() => import("./admin/ImageManager"));
const ServiceManager = lazy(() => import("./admin/ServiceManager"));
const GalleryManager = lazy(() => import("./admin/GalleryManager"));
const BookingManager = lazy(() => import("./admin/BookingManager"));
const MessagesManager = lazy(() => import("./admin/MessagesManager"));
const TestimonialsManager = lazy(() => import("./admin/TestimonialsManager"));
const SettingsManager = lazy(() => import("./admin/SettingsManager"));
const AdvancedSettingsManager = lazy(() => import("./admin/AdvancedSettingsManager"));
const PageSEOManager = lazy(() => import("./admin/PageSEOManager"));
const PasswordManager = lazy(() => import("./admin/PasswordManager"));

// Lazy load legal pages
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Admin Routes - No Navbar/Footer */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/images" element={<ImageManager />} />
            <Route path="/admin/services" element={<ServiceManager />} />
            <Route path="/admin/gallery" element={<GalleryManager />} />
            <Route path="/admin/bookings" element={<BookingManager />} />
            <Route path="/admin/messages" element={<MessagesManager />} />
            <Route path="/admin/testimonials" element={<TestimonialsManager />} />
            <Route path="/admin/settings" element={<SettingsManager />} />
            <Route path="/admin/advanced-settings" element={<AdvancedSettingsManager />} />
            <Route path="/admin/page-seo" element={<PageSEOManager />} />
            <Route path="/admin/password-change" element={<PasswordManager />} />
            
            {/* Public Routes - With Navbar/Footer */}
            <Route path="/*" element={
              <>
                <Navbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/etiquette" element={<Etiquette />} />
                  <Route path="/tribute-gifts" element={<TributeGifts />} />
                  <Route path="/travel" element={<Travel />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/booking" element={<Booking />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-of-service" element={<TermsOfService />} />
                  <Route path="/disclaimer" element={<Disclaimer />} />
                  {/* Redirect removed pages */}
                  <Route path="/dungeon" element={<Navigate to="/" replace />} />
                  <Route path="/sanctuary" element={<Navigate to="/" replace />} />
                </Routes>
                <Footer />
              </>
            } />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
